export default __webpack_public_path__ + "caecb57adfca1de3e0408aa7d15a32a5.png";